import { render, staticRenderFns } from "./HistoricoEstrategia.vue?vue&type=template&id=7d6c8b74"
import script from "./HistoricoEstrategia.vue?vue&type=script&lang=js"
export * from "./HistoricoEstrategia.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports